"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePropertiesStyleRowBandSizeDescriptor = exports.TablePropertiesStyleColumnBandSizeDescriptor = exports.TablePropertiesRowAlignmentDescriptor = exports.TablePropertiesShadingInfoDescriptor = exports.TablePropertiesLayoutTypeDescriptor = exports.TablePropertiesIndentDescriptor = exports.TablePropertiesCellSpacingDescriptor = exports.TablePropertiesLeftMarginDescriptor = exports.TablePropertiesBottomMarginDescriptor = exports.TablePropertiesRightMarginDescriptor = exports.TablePropertiesTopMarginDescriptor = exports.TablePropertiesInsideVerticalBorderDescriptor = exports.TablePropertiesInsideHorizontalBorderDescriptor = exports.TablePropertiesLeftBorderDescriptor = exports.TablePropertiesBottomBorderDescriptor = exports.TablePropertiesRightBorderDescriptor = exports.TablePropertiesTopBorderDescriptor = exports.TablePropertiesAvoidDoubleBordersDescriptor = void 0;
var table_properties_1 = require("./table-properties");
var TablePropertiesAvoidDoubleBordersDescriptor = (function () {
    function TablePropertiesAvoidDoubleBordersDescriptor() {
    }
    TablePropertiesAvoidDoubleBordersDescriptor.prototype.setProp = function (props, newValue) {
        props.avoidDoubleBorders = newValue;
    };
    TablePropertiesAvoidDoubleBordersDescriptor.prototype.getProp = function (props) {
        return props.avoidDoubleBorders;
    };
    TablePropertiesAvoidDoubleBordersDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseAvoidDoubleBorders;
    };
    return TablePropertiesAvoidDoubleBordersDescriptor;
}());
exports.TablePropertiesAvoidDoubleBordersDescriptor = TablePropertiesAvoidDoubleBordersDescriptor;
var TablePropertiesTopBorderDescriptor = (function () {
    function TablePropertiesTopBorderDescriptor() {
    }
    TablePropertiesTopBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.topBorder = newValue;
    };
    TablePropertiesTopBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.topBorder;
    };
    TablePropertiesTopBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTopBorder;
    };
    return TablePropertiesTopBorderDescriptor;
}());
exports.TablePropertiesTopBorderDescriptor = TablePropertiesTopBorderDescriptor;
var TablePropertiesRightBorderDescriptor = (function () {
    function TablePropertiesRightBorderDescriptor() {
    }
    TablePropertiesRightBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.rightBorder = newValue;
    };
    TablePropertiesRightBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.rightBorder;
    };
    TablePropertiesRightBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseRightBorder;
    };
    return TablePropertiesRightBorderDescriptor;
}());
exports.TablePropertiesRightBorderDescriptor = TablePropertiesRightBorderDescriptor;
var TablePropertiesBottomBorderDescriptor = (function () {
    function TablePropertiesBottomBorderDescriptor() {
    }
    TablePropertiesBottomBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.bottomBorder = newValue;
    };
    TablePropertiesBottomBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.bottomBorder;
    };
    TablePropertiesBottomBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseBottomBorder;
    };
    return TablePropertiesBottomBorderDescriptor;
}());
exports.TablePropertiesBottomBorderDescriptor = TablePropertiesBottomBorderDescriptor;
var TablePropertiesLeftBorderDescriptor = (function () {
    function TablePropertiesLeftBorderDescriptor() {
    }
    TablePropertiesLeftBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.leftBorder = newValue;
    };
    TablePropertiesLeftBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.leftBorder;
    };
    TablePropertiesLeftBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseLeftBorder;
    };
    return TablePropertiesLeftBorderDescriptor;
}());
exports.TablePropertiesLeftBorderDescriptor = TablePropertiesLeftBorderDescriptor;
var TablePropertiesInsideHorizontalBorderDescriptor = (function () {
    function TablePropertiesInsideHorizontalBorderDescriptor() {
    }
    TablePropertiesInsideHorizontalBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.insideHorizontalBorder = newValue;
    };
    TablePropertiesInsideHorizontalBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.insideHorizontalBorder;
    };
    TablePropertiesInsideHorizontalBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseInsideHorizontalBorder;
    };
    return TablePropertiesInsideHorizontalBorderDescriptor;
}());
exports.TablePropertiesInsideHorizontalBorderDescriptor = TablePropertiesInsideHorizontalBorderDescriptor;
var TablePropertiesInsideVerticalBorderDescriptor = (function () {
    function TablePropertiesInsideVerticalBorderDescriptor() {
    }
    TablePropertiesInsideVerticalBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.insideVerticalBorder = newValue;
    };
    TablePropertiesInsideVerticalBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.insideVerticalBorder;
    };
    TablePropertiesInsideVerticalBorderDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseInsideVerticalBorder;
    };
    return TablePropertiesInsideVerticalBorderDescriptor;
}());
exports.TablePropertiesInsideVerticalBorderDescriptor = TablePropertiesInsideVerticalBorderDescriptor;
var TablePropertiesTopMarginDescriptor = (function () {
    function TablePropertiesTopMarginDescriptor() {
    }
    TablePropertiesTopMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.top = newValue;
    };
    TablePropertiesTopMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.top;
    };
    TablePropertiesTopMarginDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTopMargin;
    };
    return TablePropertiesTopMarginDescriptor;
}());
exports.TablePropertiesTopMarginDescriptor = TablePropertiesTopMarginDescriptor;
var TablePropertiesRightMarginDescriptor = (function () {
    function TablePropertiesRightMarginDescriptor() {
    }
    TablePropertiesRightMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.right = newValue;
    };
    TablePropertiesRightMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.right;
    };
    TablePropertiesRightMarginDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseRightMargin;
    };
    return TablePropertiesRightMarginDescriptor;
}());
exports.TablePropertiesRightMarginDescriptor = TablePropertiesRightMarginDescriptor;
var TablePropertiesBottomMarginDescriptor = (function () {
    function TablePropertiesBottomMarginDescriptor() {
    }
    TablePropertiesBottomMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.bottom = newValue;
    };
    TablePropertiesBottomMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.bottom;
    };
    TablePropertiesBottomMarginDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseBottomMargin;
    };
    return TablePropertiesBottomMarginDescriptor;
}());
exports.TablePropertiesBottomMarginDescriptor = TablePropertiesBottomMarginDescriptor;
var TablePropertiesLeftMarginDescriptor = (function () {
    function TablePropertiesLeftMarginDescriptor() {
    }
    TablePropertiesLeftMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.left = newValue;
    };
    TablePropertiesLeftMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.left;
    };
    TablePropertiesLeftMarginDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseLeftMargin;
    };
    return TablePropertiesLeftMarginDescriptor;
}());
exports.TablePropertiesLeftMarginDescriptor = TablePropertiesLeftMarginDescriptor;
var TablePropertiesCellSpacingDescriptor = (function () {
    function TablePropertiesCellSpacingDescriptor() {
    }
    TablePropertiesCellSpacingDescriptor.prototype.setProp = function (props, newValue) {
        props.cellSpacing = newValue;
    };
    TablePropertiesCellSpacingDescriptor.prototype.getProp = function (props) {
        return props.cellSpacing;
    };
    TablePropertiesCellSpacingDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseCellSpacing;
    };
    return TablePropertiesCellSpacingDescriptor;
}());
exports.TablePropertiesCellSpacingDescriptor = TablePropertiesCellSpacingDescriptor;
var TablePropertiesIndentDescriptor = (function () {
    function TablePropertiesIndentDescriptor() {
    }
    TablePropertiesIndentDescriptor.prototype.setProp = function (props, newValue) {
        props.indent = newValue;
    };
    TablePropertiesIndentDescriptor.prototype.getProp = function (props) {
        return props.indent;
    };
    TablePropertiesIndentDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTableIndent;
    };
    return TablePropertiesIndentDescriptor;
}());
exports.TablePropertiesIndentDescriptor = TablePropertiesIndentDescriptor;
var TablePropertiesLayoutTypeDescriptor = (function () {
    function TablePropertiesLayoutTypeDescriptor() {
    }
    TablePropertiesLayoutTypeDescriptor.prototype.setProp = function (props, newValue) {
        props.layoutType = newValue;
    };
    TablePropertiesLayoutTypeDescriptor.prototype.getProp = function (props) {
        return props.layoutType;
    };
    TablePropertiesLayoutTypeDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTableLayout;
    };
    return TablePropertiesLayoutTypeDescriptor;
}());
exports.TablePropertiesLayoutTypeDescriptor = TablePropertiesLayoutTypeDescriptor;
var TablePropertiesShadingInfoDescriptor = (function () {
    function TablePropertiesShadingInfoDescriptor() {
    }
    TablePropertiesShadingInfoDescriptor.prototype.setProp = function (props, newValue) {
        props.shadingInfo = newValue;
    };
    TablePropertiesShadingInfoDescriptor.prototype.getProp = function (props) {
        return props.shadingInfo;
    };
    TablePropertiesShadingInfoDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseShadingInfoIndex;
    };
    return TablePropertiesShadingInfoDescriptor;
}());
exports.TablePropertiesShadingInfoDescriptor = TablePropertiesShadingInfoDescriptor;
var TablePropertiesRowAlignmentDescriptor = (function () {
    function TablePropertiesRowAlignmentDescriptor() {
    }
    TablePropertiesRowAlignmentDescriptor.prototype.setProp = function (props, newValue) {
        props.tableRowAlignment = newValue;
    };
    TablePropertiesRowAlignmentDescriptor.prototype.getProp = function (props) {
        return props.tableRowAlignment;
    };
    TablePropertiesRowAlignmentDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTableAlignment;
    };
    return TablePropertiesRowAlignmentDescriptor;
}());
exports.TablePropertiesRowAlignmentDescriptor = TablePropertiesRowAlignmentDescriptor;
var TablePropertiesStyleColumnBandSizeDescriptor = (function () {
    function TablePropertiesStyleColumnBandSizeDescriptor() {
    }
    TablePropertiesStyleColumnBandSizeDescriptor.prototype.setProp = function (props, newValue) {
        props.tableStyleColumnBandSize = newValue;
    };
    TablePropertiesStyleColumnBandSizeDescriptor.prototype.getProp = function (props) {
        return props.tableStyleColumnBandSize;
    };
    TablePropertiesStyleColumnBandSizeDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTableStyleColBandSize;
    };
    return TablePropertiesStyleColumnBandSizeDescriptor;
}());
exports.TablePropertiesStyleColumnBandSizeDescriptor = TablePropertiesStyleColumnBandSizeDescriptor;
var TablePropertiesStyleRowBandSizeDescriptor = (function () {
    function TablePropertiesStyleRowBandSizeDescriptor() {
    }
    TablePropertiesStyleRowBandSizeDescriptor.prototype.setProp = function (props, newValue) {
        props.tableStyleRowBandSize = newValue;
    };
    TablePropertiesStyleRowBandSizeDescriptor.prototype.getProp = function (props) {
        return props.tableStyleRowBandSize;
    };
    TablePropertiesStyleRowBandSizeDescriptor.prototype.maskValue = function () {
        return table_properties_1.TablePropertiesMask.UseTableStyleRowBandSize;
    };
    return TablePropertiesStyleRowBandSizeDescriptor;
}());
exports.TablePropertiesStyleRowBandSizeDescriptor = TablePropertiesStyleRowBandSizeDescriptor;
